import React, { useEffect, useState } from "react";
import useAxios from "../../../Utils/useAxios";
import StepSatu from "../FormSusulan/StepSatu";
import StepDua from "../FormSusulan/StepDua";
import StepTiga from "../FormSusulan/StepTiga";
import FormStepContainer from "../../../Layout/Containers/FormStepContainer";
import {
  getGroupDokumenTransaksi,
  getTransaksi,
  getUserRole,
} from "../services";

const BuatSusulan = () => {
  const axiosInstance = useAxios();

  const [selectedTransaksi, setSelectedTransaksi] = useState(null);
  const [formGroupTransaksi, setFormGroupTransaksi] = useState([]);
  const [selectedGroupTransaksi, setSelectedGroupTransaksi] = useState(null);
  const [selectedUsername, setSelectedUsername] = useState("");
  const [groupTransaksiList, setGroupTransaksiList] = useState([]);
  const [transaksiList, setTransaksiList] = useState([]);
  const [userRoleOpt, setUserRoleOpt] = useState([]);
  const [step, setStep] = useState(0);
  const [pending, setPending] = useState({
    groupTransaksi: true,
    transaksi: true,
  });

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      const { data: groupDokumenTransaksiData } =
        await getGroupDokumenTransaksi(axiosInstance).then((res) => {
          setPending((prev) => ({ ...prev, groupTransaksi: false }));
          return res;
        });
      setGroupTransaksiList(groupDokumenTransaksiData);

      const { data: transaksiData } = await getTransaksi(axiosInstance).then(
        (res) => {
          setPending((prev) => ({ ...prev, transaksi: false }));
          return res;
        }
      );
      setTransaksiList(transaksiData);

      const userRoleKeuanganData = await getUserRole(axiosInstance).then(
        (res) => res.data.filter((item) => item.id_unit_kerja === "Keuangan")
      );
      setUserRoleOpt(
        userRoleKeuanganData.map((item) => ({
          value: item.username,
          label: item.username,
          name: "username",
        }))
      );
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  const updateCheckbox = (selectedRows) => {
    setSelectedTransaksi(selectedRows);
    setFormGroupTransaksi((prev) => ({
      ...prev,
      group_transaksi: selectedRows.map((item) => item.id),
    }));
  };

  const updateFormGroupTransaksi = (data) => {
    setFormGroupTransaksi(data);
  };

  const handleRadio = (row) => {
    const selectedRow = row.selectedRows[0];
    setSelectedGroupTransaksi(selectedRow);
    if (selectedRow !== undefined) {
      setFormGroupTransaksi(selectedRow);
      setSelectedUsername({
        value: selectedRow.username_pic_keuangan,
        label: selectedRow.username_pic_keuangan,
        name: "username",
      });
    }
  };

  const handleInputUsername = (e) => {
    const { value } = e;
    setFormGroupTransaksi((prev) => ({
      ...prev,
      username_pic_keuangan: value,
      username_email: value,
    }));
    setSelectedUsername(e);
  };

  const handleDelete = (row) => {
    setSelectedTransaksi((prev) => prev.filter((item) => item.id !== row.id));
    setFormGroupTransaksi((prev) => ({
      ...prev,
      group_transaksi: prev.group_transaksi.filter(
        (item_id) => item_id !== row.id
      ),
    }));
  };

  const handleNext = (e) => {
    setStep(step + 1);
  };

  const handlePrev = (e) => {
    setStep(step - 1);
  };

  return (
    <FormStepContainer step={step}>
      <StepSatu
        handleRadio={handleRadio}
        selectedGroupTransaksi={selectedGroupTransaksi}
        groupTransaksiList={groupTransaksiList}
        transaksiList={transaksiList}
        pending={pending?.groupTransaksi}
        handleNext={handleNext}
      />

      <StepDua
        formGroupTransaksi={formGroupTransaksi}
        transaksiList={transaksiList}
        userRoleOpt={userRoleOpt}
        selectedGroupTransaksi={selectedGroupTransaksi}
        selectedUsername={selectedUsername}
        updateCheckbox={updateCheckbox}
        handleInputUsername={handleInputUsername}
        pending={pending?.transaksi}
        handlePrev={handlePrev}
        handleNext={handleNext}
      />
      <StepTiga
        formGroupTransaksi={formGroupTransaksi}
        updateFormGroupTransaksi={updateFormGroupTransaksi}
        transaksiList={selectedTransaksi}
        handleDelete={handleDelete}
        step={step}
        handlePrev={handlePrev}
        handleNext={handleNext}
      />
    </FormStepContainer>
  );
};
export default BuatSusulan;
